var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-lp-promotion-plp"},[_c('PLP',{attrs:{"preview-data":_vm.plp,"params":_vm.sendParams,"hidden-filter":false,"is-display-sort":true,"wcm-columns":_vm.columns,"title":_vm.activityInfo.activityName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }